import request from '@/config/axios'

export interface TeamRewardTier {
  directCount: number
  rewardPrice: number // 分
}

export interface TeamRewardConfigVO {
  id?: number
  enabled: boolean
  tiers: TeamRewardTier[]
}

export const getTeamRewardConfig = async () => {
  return await request.get<TeamRewardConfigVO>({ url: '/trade/brokerage-team-reward/get' })
}

export const saveTeamRewardConfig = async (data: TeamRewardConfigVO) => {
  return await request.put({ url: '/trade/brokerage-team-reward/save', data })
}

export const settleTeamReward = async () => {
  return await request.post<number>({ url: '/trade/brokerage-team-reward/settle' })
}

export interface TeamRewardTierPreview {
  directCount: number
  rewardPrice: number
  reached: boolean
  granted: boolean
  wouldGrantNow: boolean
}

export interface TeamRewardPreviewVO {
  userId: number
  enabled: boolean
  directCount: number
  configId?: number
  tiers: TeamRewardTierPreview[]
}

export const previewTeamReward = async (userId: number) => {
  return await request.get<TeamRewardPreviewVO>({
    url: '/trade/brokerage-team-reward/preview',
    params: { userId }
  })
}
